import { Component, EventEmitter, forwardRef, Input, Output } from "@angular/core";
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
	template: "",
})
export class BaseSelectComponent {
	@Input() public placeholder: string = "";
	@Input() public bindLabel: string | string[];
	@Input() public clearable = true;
	@Input() public searchable = true;
	@Input() public bindValue: string;
	@Input() public formControl: FormControl;
	@Input() public loading: boolean;
	@Input() public readonly: boolean;
	@Input() public multiple: boolean = false;
	@Input() public hidden: boolean = false;
	@Output() selectionChange = new EventEmitter<any>();
	@Output() public clear = new EventEmitter();
	@Output() public focus = new EventEmitter<void>();

	onSelect(selectedItem: any) {
		this.selectionChange.emit(selectedItem);
	}
}
